import { Grid } from "@material-ui/core";
import React from "react";
import InicioCard from "../../../components/InicioCard";
import AAFFIcon from "../../../images/aaff.png"
import AlarmaIcon from "../../../images/alarm.png"
import ConsultoresIcon from "../../../images/consultores.png"

function Inicio() {
  return (<>
    <div style={{
      textAlign: 'center',
      fontSize: 28,
      color: "#303248",
      fontWeight: 'bold',
      marginTop: 90
    }}></div>
    <div style={{
      textAlign: 'center',
      fontSize: 22,
      color: "#303248",
      marginTop: 10,
      marginBottom: 70
    }}></div>
    <Grid container direction="row" justify="center" alignItems="center" spacing={5}>
      <Grid item><InicioCard texto1="Bienvenido a tu gestor de fincas" texto2="Donde podrás gestionar toda la documentación de comunidades y proveedores." /></Grid>
    </Grid>
    {/* <div style={{
      textAlign: 'center',
      fontSize: 28,
      color: "#303248",
      fontWeight: 'bold',
      marginTop: 90
    }}>Bienvenido a tu gestor de fincas</div>
    <div style={{
      textAlign: 'center',
      fontSize: 22,
      color: "#303248",
      marginTop: 10,
      marginBottom: 70
    }}>¿QUÉ QUIERES HACER?</div>
    <Grid container direction="row" justify="center" alignItems="center" spacing={5}>
      <Grid item><InicioCard icono={ConsultoresIcon} texto="Gestionar Administradores de Fincas" ruta="/aaff" /></Grid>
      <Grid item><InicioCard icono={AAFFIcon} texto="Gestionar Comunidades" ruta="/comunidades" /></Grid>
      <Grid item><InicioCard icono={AlarmaIcon}  texto="Gestionar Alertas de proveedores" ruta="/alertas" /></Grid>
    </Grid> */}
  </>);
}

export default Inicio;
